import { render, staticRenderFns } from "./GraphDetail57.vue?vue&type=template&id=58b758d8&scoped=true&"
import script from "./GraphDetail57.vue?vue&type=script&lang=js&"
export * from "./GraphDetail57.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b758d8",
  null
  
)

export default component.exports